// stahlia-frontend/src/lib/workers-form.ts
// Formular-Validierung Mitarbeiter-Verwaltung (Spiegel der zod-Regeln in
// src/modules/warehouse/types.ts workerCreateSchema).
import type { WarehouseWorker } from '@/api/warehouse'
export const PIN_RE = /^\d{4}$/
export const LEERPLATZ_RECHT = { feld: 'can_leerplatz_pruefen', label: 'Leere Plätze prüfen',
  hinweis: 'Darf in der App leere Fächer bestätigen' } as const
/** 0165: eigene Kachel „Packplatz setzen“; wirkt nur, wenn der Modul-Schalter an ist. */
export const PACKPLATZ_RECHT = { feld: 'can_packplatz_setzen', label: 'Packplatz setzen',
  hinweis: 'Darf in der App Packplätze setzen' } as const
/** 0172: eigene Kachel „NULL-MENGEN zählen“; wirkt nur, wenn der Modul-Schalter an ist. */
export const NULLMENGEN_RECHT = { feld: 'can_nullmengen', label: 'NULL-MENGEN zählen',
  hinweis: 'Darf in der App leere Grundartikel am Packort nachzählen' } as const

/** Independent Priostahl rights; missing fields are displayed as false. */
export const PRIOSTAHL_RECHTE = [
  { feld: 'can_priostahl_erstaufnahme', label: 'Priostahl Erstaufnahme', hinweis: 'Erste und erneute Aufnahme' },
  { feld: 'can_priostahl_nachschub', label: 'Priostahl Picken', hinweis: 'Nachschub anfordern' },
  { feld: 'can_priostahl_pick', label: 'Priostahl Kommissionieren', hinweis: 'Kommissionier-Aufträge bearbeiten' },
  { feld: 'can_priostahl_umfahren', label: 'Priostahl Umfahren', hinweis: 'Aufgenommene Paletten innerhalb Lager 2 umfahren' },
] as const satisfies ReadonlyArray<{ feld: keyof WarehouseWorker; label: string; hinweis: string }>

/** Missing legacy rights may have server defaults: only explicit false is a pure profile. */
export function standardWorkRightsDisabled(worker: WarehouseWorker): boolean {
  return worker.can_leerplatz_pruefen !== true && worker.can_packplatz_setzen !== true && worker.can_nullmengen !== true && [worker.can_einlagern, worker.can_umfahren, worker.can_info, worker.can_buchungen,
    worker.can_inventur, worker.can_erstaufnahme, worker.can_handregal, worker.can_wareneingang,
    worker.can_nachschub, worker.can_pick].every(right => right === false)
}

export function validateWorkerForm(name: string, pin: string): string | null {
  if (name.trim().length < 2) return 'Name zu kurz (mind. 2 Zeichen)'
  if (name.trim().length > 60) return 'Name zu lang (max. 60 Zeichen)'
  if (!PIN_RE.test(pin)) return 'PIN muss genau 4 Ziffern haben'
  return null
}
